/* @import '../../../../../../node_modules/ag-grid-enterprise/styles/ag-grid.css';
@import '../../../../../../node_modules/ag-grid-enterprise/styles/ag-theme-material.css'; */

.container {
    width: 100%;
    height: 100%;
    background-color: #f2f2f2; /* light grey background */
    overflow: auto; /* enable scrolling */
  
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
      display: none;
    }
  
    /* Hide scrollbar for Firefox */
    scrollbar-width: none;
  
    /* Hide scrollbar for IE and Edge */
    -ms-overflow-style: none;
  }
  